import React from 'react';
import Button, {
  buttonRootStyle,
} from '@teetsh/app/src/components/Buttons/Button';
import tw from 'twin.macro';
import { Option } from './types';
import { textColors } from '@teetsh/app/src/components/colors';
import { Intent } from '@teetsh/app/src/components/Buttons/BaseButtonProps';

interface Props<T> {
  option?: Option<T>;
  intent?: Intent;
  loading?: boolean;
  fill?: boolean;
  withIcon?: boolean;
}

export function DisplayButton<T>(props: Props<T>) {
  const { intent, option } = props;

  if (option?.onClick) {
    return (
      <Button
        fill={props.fill}
        loading={props.loading}
        onClick={option?.onClick}
        icon={props.withIcon && option?.icon}
        alignText="left"
        intent={intent}
      >
        {option?.label}
      </Button>
    );
  }
  return (
    <div
      className="tsh-button"
      css={[
        buttonRootStyle({
          large: true,
          disableIconColor: true,
        }),
        tw`rounded-r-none px-3 hover:bg-opacity-0 hover:bg-white!`,
      ]}
    >
      <div>
        <svg
          css={[option?.color && textColors(option?.color)]}
          tw="mr-1.5 h-3 w-3"
          fill="currentColor"
          viewBox="0 0 8 8"
        >
          <circle cx={4} cy={4} r={3} />
        </svg>
      </div>
      <p tw="ml-1 text-base font-medium">{option?.label}</p>
    </div>
  );
}
